import type { ChatbotState } from '../index';

export const toggleFullScreen = (state: ChatbotState) => {
  state.fullScreen = !state.fullScreen;
};
